module.exports = __webpack_public_path__ + "img/banner2.c4b5f96.jpg";